<template>
    <div>
        <el-dialog v-if="dialogVisible" v-el-drag-dialog title="部门议题报送" :visible.sync="dialogVisible" width="1400px" :close-on-click-modal="false" :destroy-on-close="true" @close="toClose">
            <div>
                <el-form :model="dzggObj">
                    <div style="width: 100%" class="el-table el-table--fit el-table--border">
                        <div class="el-table__body-wrapper">
                            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                                <tbody>
                                    <tr>
                                        <td ref="tdlbl_议题征集任务" class="el-table__cell tdlbl tdw17" colspan="1">
                                            <span class="field">议题征集任务</span>
                                        </td>
                                        <td class="el-table__cell tdcont tdw83" colspan="5">
                                            <el-input v-model="searchObj.title" v-listpage-dialog listviewurl="hygl.ytsjInfo.list" dialog-title="选择文件" exclude-fields="status,field_option" :multiple="false" placeholder="请选择文件" name="tittle"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="el-table__cell tdcont tdw100" colspan="6">报送议题明细</td>
                                    </tr>
                                    <tr>
                                        <td class="el-table__cell tdcont tdw100 table_data" colspan="6" style="padding: 0px">
                                            <el-table :data="tableData" style="width: 100%">
                                                <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
                                                <el-table-column prop="subject" label="会议议题" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="subjectTypeName" label="会议类型" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="mainDept" label="主办部门" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="reportPersonName" label="陈述人" width="110" align="center" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="reportTime" label="陈述时间/分钟" width="110" align="center" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="talkTime" label="讨论时间/分钟" width="110" align="center" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="attendDept" label="列席部门" width="200" align="center" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="generateType" label="议题来源" width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
                                                <el-table-column prop="createDate" label="创建时间" width="130" align="center" :show-overflow-tooltip="true">
                                                    <template slot-scope="scope">
                                                        <div>{{ '2024-07-15 10:23' }}</div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="reportEndTime" label="征集结束时间" width="130" align="center" :show-overflow-tooltip="true">
                                                    <template slot-scope="scope">
                                                        <div>{{ '2024-07-15 10:23' }}</div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="" label="附件" width="70" align="center">
                                                    <template slot-scope="scope">
                                                        <div>{{ '1' }}</div>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="caozuo" label="操作" width="80" align="center">
                                                    <template slot-scope="scope">
                                                        <div style="display: flex; justify-content: space-evenly; color: #1a82e3">
                                                            <span>移除</span>
                                                        </div>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="toClose">取 消</el-button>
                <el-button type="primary" @click="submitHandle">报 送</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            return val ? moment(val).format('YYYY-MM-DD HH:mm') : ''
        }
    },
    components: {},
    props: {},
    data() {
        return {
            dialogVisible: false,
            searchObj: {
                title: '',
                taskId: ''
            },
            tableData: [],
            loginUser: this.$store.getters.loginUser,
            deptId: ''
        }
    },
    computed: {},
    watch: {},
    created() {
        this.loginUser.staffList.forEach((item) => {
            var idArr = item.orgFullId.split('-')
            this.deptId = idArr[idArr.length - 1] + ','
        })
        // var staffDeptId = this.loginUser.staffList
        console.log('deptId', this.deptId)
        this.deptId = this.deptId.substring(0, this.deptId.length - 1)
        this.$bus.on('openDeptIssueReport', this.openDeptIssueReport)
    },
    beforeDestroy() {
        this.$bus.off('openDeptIssueReport', this.openDeptIssueReport)
    },
    mounted() {},
    methods: {
        openDeptIssueReport(list) {
            this.tableData = list
            this.dialogVisible = true
        },
        // 通用列表选择对话框-加载数据前回调
        onDialogListDataBeforeLoad($scope, qparams) {
            console.log($scope.moduleInfo.moduleCode, 'onDialogListDataBeforeLoad')
            var time = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            if ($scope.moduleInfo.moduleCode === 'ytsjInfo') {
                qparams.urlsearch = `endTime>${time}`
                qparams.filter = 'dept'
                qparams.orderBy = `startTime desc`
            }
        },
        // 通用列表选择对话框-选择数据后回调
        onSelectListpageRowCompleted(selectedRows, attr) {
            console.log(selectedRows)

            this.searchObj.title = selectedRows[0].content
            this.searchObj.taskId = selectedRows[0].parentId
        },
        // 移除
        deleteHandle(row, index) {
            this.tableData.splice(index, 1)
        },
        // 确认
        submitHandle() {
            if (!this.searchObj.taskId) {
                this.$alert(this.$tx('hygl.ytRecord.noTaskId', '请选择议题征集任务。'), this.$tx('hygl.ytRecord.optionTip', '操作提示'), { type: 'warning' })
                return
            }
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `/hygl/ytRecord/ytSubmitted`,
                method: 'POST',
                params: {
                    jtsjId: this.searchObj.taskId
                },
                data: this.tableData
            }).then((res) => {
                if (res.code === 'success') {
                    this.$message.success(this.$tx('hygl.ytRecord.saveSuccess', '保存成功。'))
                    this.dialogVisible = false
                    this.$bus.emit('refreshListData')
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 关闭
        toClose() {
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.dialog_top {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .el-button {
        margin-left: 10px;
        padding: 8px 15px;
    }
}
.table_data .el-table::before {
    background-color: #fff !important;
}
</style>
